import axios, { clientContext } from './config'

// AUTH
const apiReview = {
  getClientReviewsSummary () {
    return axios.get(`/api/clients/${clientContext.getUsername()}/reviews_summary/`)
  },
  submitReviews (data) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/submit_reviews/`, data)
  },
  swapItems (data) {
    return axios.post('/api/packageitems/mark_returning/', data)
  },
  updateReviewPhotos (reviewId, images) {
    return axios.put('/api/itemfeedbacks/' + reviewId + '/images/', images)
  }
}

export default apiReview
